import React, { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import ChatterLayout from '../components/ChatterLayout'
import OpportunityChatter from '../components/OpportunityChatter'
import ChatterWelcome from '../components/ChatterWelcome'
import { useChatterList } from '../hooks/useChatterList'

const ChatterPage: React.FC = () => {
  const { opportunityId } = useParams<{ opportunityId?: string }>()
  const navigate = useNavigate()
  const { conversations, loading } = useChatterList()

  // Auto-select the most recent conversation if none is selected
  useEffect(() => {
    if (!opportunityId && !loading && conversations.length > 0) {
      // Sort conversations by last activity and select the most recent one
      const sortedConversations = [...conversations].sort((a, b) => 
        new Date(b.lastActivity).getTime() - new Date(a.lastActivity).getTime()
      )
      const mostRecentOpportunityId = sortedConversations[0].opportunityId
      navigate(`/chatter/${mostRecentOpportunityId}`, { replace: true })
    }
  }, [opportunityId, loading, conversations, navigate])

  return (
    <ChatterLayout selectedOpportunityId={opportunityId}>
      {opportunityId ? (
        <OpportunityChatter />
      ) : (
        <ChatterWelcome />
      )}
    </ChatterLayout>
  )
}

export default ChatterPage
